import { render, staticRenderFns } from "./JGLogCom.vue?vue&type=template&id=ea761528&"
import script from "./JGLogCom.vue?vue&type=script&lang=ts&"
export * from "./JGLogCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports